import { render, staticRenderFns } from "./SlicesArea.vue?vue&type=template&id=3ef5b58b&"
import script from "./SlicesArea.vue?vue&type=script&lang=js&"
export * from "./SlicesArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports